<script>
export default {
  props: {
    c: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<template>
  <a :href="`/blog/${c.slug}`" class="w-full flex relative overflow-hidden bg-lightgray items-end" style="padding-top: 66.66666667%">
    <img class="absolute lazyload inset-0 w-full h-full object-cover object-center hover:scale-110 transform !transition-all duration-500 origin-center" v-if="c.acf.image" :data-src="c.acf.image.sizes.medium_large" :alt="c.title.rendered" />
    <div class="absolute inset-0 w-full h-full from-dark to-transparent pointer-events-none opacity-25 bg-gradient-to-tr"></div>
    <div class="absolute inset-0 w-full p-20 h-full flex flex-col justify-between items-start pointer-events-none">
      <p v-if="c.categories_objects && c.categories_objects.length" class="highlight bg-black text-white" v-html="c.categories_objects.map(o => o.name).join(', ')"></p>
      <span class="text-20 mt-auto font-bold tracking-normal text-white leading-26">{{ c.title.rendered }}</span>
    </div>
  </a>
</template>
